// The public Trust Center's copy of the shared style keys (same names as
// TrustCenter.styles.js, which the admin keeps using unchanged). Public
// components import this one.
import { fontRendering, tokens } from "./publicTheme";

const t = tokens();

export const PAGE_MAX_WIDTH = 1200;

export const publicStyles = {
  // body has overflow-y: hidden app-wide, so the page scrolls itself.
  page: {
    ...fontRendering,
    height: "100vh",
    // A column, so the footer (margin-top: auto) sits at the bottom of the
    // screen when a tab is short. Nothing shrinks to make room.
    display: "flex",
    flexDirection: "column",
    "& > *": { flexShrink: 0 },
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: t.paper,
    color: t.ink,
    scrollBehavior: "smooth",
    "@media (prefers-reduced-motion: reduce)": { scrollBehavior: "auto" },
  },
  pageInner: {
    maxWidth: PAGE_MAX_WIDTH,
    width: "100%",
    minWidth: 0,
    mx: "auto",
    px: { xs: 2, sm: 3, lg: 4 },
    py: { xs: 3, md: 4 },
    boxSizing: "border-box",
  },
  mainCard: {
    borderRadius: `${t.radius.container}px`,
    boxShadow: "none",
    border: `1px solid ${t.line}`,
    backgroundColor: t.surface,
    scrollMarginTop: "140px",
    minWidth: 0,
  },
  cardHeader: {
    flexWrap: "wrap",
    rowGap: 1.5,
    borderBottom: "none",
    background: "transparent",
    px: 2.5,
    pt: 2.25,
    pb: 1.5,
    ".MuiCardHeader-title": {
      fontSize: "17px",
      fontWeight: 600,
      letterSpacing: "-0.01em",
      color: t.ink,
    },
    ".MuiCardHeader-subheader": { fontSize: "13px", color: t.muted },
    ".MuiCardHeader-content": { minWidth: { xs: "100%", sm: 0 } },
    ".MuiCardHeader-action": {
      m: 0,
      alignSelf: "center",
      width: { xs: "100%", sm: "auto" },
    },
  },
  // A quiet count next to a heading (was a dashed box).
  countBox: {
    display: "inline-flex",
    alignItems: "center",
    px: 1,
    py: 0.25,
    borderRadius: `${t.radius.pill}px`,
    backgroundColor: t.paper,
    fontSize: "12px",
    fontWeight: 500,
    color: t.inkSoft,
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
  },
  statsCard: {
    p: 2,
    borderRadius: `${t.radius.container}px`,
    border: `1px solid ${t.line}`,
    backgroundColor: t.surface,
    flex: 1,
    minWidth: 0,
    boxSizing: "border-box",
  },
};

export { publicStyles as styles };
